import { ChannelView, setGmailFromUrl } from '@elva/ui';
import type { Channel } from '@elva/ui';
import { useWorkspaceLabel } from '@elva/platform';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * AI Brain › Channels (spec 15 §9.4). One shape, three instances.
 * No channel-settings API — stage's mock for call, text, and email.
 * On Email, the Gmail card reads the shared store, seeded from `?gmail=` / `?role=` (spec 38).
 */
export function SettingsChannelPage({ channel }: { channel: Channel }) {
  const location = useWorkspaceLabel();
  const [params] = useSearchParams();
  const gmail = params.get('gmail');
  const role = params.get('role');
  useEffect(() => {
    setGmailFromUrl(gmail, role);
  }, [gmail, role]);

  return <ChannelView channel={channel} location={location} />;
}
